import { gql } from '@apollo/client';

export const sendPlaylistReminder = gql`
  mutation sendPlaylistReminder($playlistId: ID!) {
    sendPlaylistReminder(playlistId: $playlistId) {
      id
      lastReminderAt
    }
  }
`;

export const sendPlaylistUserReminder = gql`
  mutation sendPlaylistUserReminder($input: PlaylistUserReminderInput!) {
    sendPlaylistUserReminder(input: $input) {
      playlistId
      userId
      lastReminderAt
    }
  }
`;
